import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import SimpleBar from 'simplebar-react';

const useStyles = makeStyles((theme) => ({
  simplebar: {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '100%',
    minWidth: 785,
    paddingRight: theme.spacing(theme.subpageDrawer.paddings.desktop.horizontal),
    marginRight: -theme.spacing(theme.subpageDrawer.paddings.desktop.horizontal),
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(theme.subpageDrawer.paddings.mobile.horizontal),
      marginRight: -theme.spacing(theme.subpageDrawer.paddings.mobile.horizontal),
    },
    [theme.breakpoints.down('md')]: {
      minWidth: '100%',
    },
    '& .simplebar-track': {
      margin: '15vh 24px 15vh 0',
      [theme.breakpoints.down('sm')]: {
        margin: '15vh 12px 15vh 0',
      },
      backgroundImage:
        `linear-gradient(
          0deg,
          transparent 70%,
          ${theme.palette.primary.main} 20%
        )`,
      backgroundSize: '10px 13px',
      padding: 0,
      width: 3,
      overflow: 'visible',
    },
    '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before': {
      opacity: 1,
      width: 5,
      borderRadius: 0,
      marginLeft: -3,
      backgroundColor: theme.palette.primary.main,
    },
    '& .simplebar-wrapper': {
      maxHeight: '100dvh',
    },
  },
}));

const CartierSimplebar = ({
  children, className, rootRef, ...otherProps
}) => {
  const classes = useStyles();

  return (
    <SimpleBar
      className={clsx(classes.simplebar, className)}
      {...otherProps}
      ref={rootRef}
    >
      {children}
    </SimpleBar>
  );
};

CartierSimplebar.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  rootRef: PropTypes.shape({
    current: PropTypes.shape({
      getScrollElement: PropTypes.func,
    }),
  }),
};

CartierSimplebar.defaultProps = {
  className: undefined,
  rootRef: undefined,
};

export default CartierSimplebar;
